import React from 'react';
// Mui components
import { Box, Button, Typography } from '@mui/material';
// Components
import SmallModalContainer from '../../common/SmallModalContainer';
// Icons
import iconCheck from '../../../assets/icons/icon_circle-check.svg';

function ModalSucessInformarProveedor({ openModal, onHandleClose }) {
    return (
        <SmallModalContainer open={openModal}
            onClose={onHandleClose}>
            <Box display="flex" flexDirection="column" gap={"1rem"}>
                <Box
                    component="img"
                    sx={{ width: "54px", height: "54px" }}
                    alt="img not found"
                    src={iconCheck}
                />
                <Typography variant="h1">Recibimos la información</Typography>
                <Typography variant="h5" component="p">Veremos si es posible integrarnos para que puedas conectar esa agenda con la de OSDE.</Typography>
                <Box display="flex" gap={"1rem"} marginTop="1.5rem">
                    <Button
                        onClick={onHandleClose}
                        variant="contained"
                        sx={{ height: "48px", borderRadius: "16px", width: "100%" }}>
                        <Typography variant="cta" component="span">Entendido</Typography>
                    </Button>
                </Box>
            </Box>
        </SmallModalContainer>
    );
}

export default ModalSucessInformarProveedor;